angular.module("eCareVault.common.mugshotList", []);
